import { useQuery } from '@tanstack/react-query';
import { menuService } from '../../services/menu.service';

export const useMenuCategories = () => {
    return useQuery({
        queryKey: ['menu-categories'],
        queryFn: menuService.getCategories,
        staleTime: 1000 * 60 * 30, // 30 mins
    });
};

export const useProducts = () => {
    return useQuery({
        queryKey: ['products'],
        queryFn: menuService.getProducts,
        staleTime: 1000 * 60 * 15, // 15 mins
    });
};

export const useMenus = () => {
    return useQuery({
        queryKey: ['menus'],
        queryFn: menuService.getMenus,
        staleTime: 1000 * 60 * 30, // 30 mins
    });
};

export const useOffers = () => {
    return useQuery({
        queryKey: ['offers'],
        queryFn: menuService.getOffers,
        staleTime: 1000 * 60 * 15,
    });
};

export const useUpcomingOffers = () => {
    return useQuery({
        queryKey: ['upcoming-offers'],
        queryFn: menuService.getUpcomingOffers,
        staleTime: 1000 * 60 * 15,
    });
};
